import { loginApi, logoutApi } from '../api/authAPI';
import { User } from '../types/User';
import { isTokenExpired, requestAccessToken } from '../util/token';
import { requestPermission } from '../util/firebase';

export const checkAndRefreshToken = async () => {
  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  if(accessToken && !isTokenExpired(accessToken)) {
    return true;
  }
  if (accessToken && isTokenExpired(accessToken) && refreshToken && !isTokenExpired(refreshToken)) {
    await requestAccessToken(refreshToken);
    return true;
  }

  return false;
};

export const login = async (email: string, password: string) => {
  // 실제 백엔드 API 호출 로직
  const device = {
    fId: localStorage.getItem('fId'),
    os: 'web',
    name: 'browser',
    model: 'chrome',
    device: 'desktop',
    version: '1.0.0',
  }

  if (!device.fId) {
    await requestPermission();
  }

  try {
    const response = await loginApi({ email, password, device });
    console.log(response.data);
    if (response.status !== 200) {
      throw new Error('Login failed');
    }
    localStorage.setItem('accessToken', response.data.accessToken);
    localStorage.setItem('refreshToken', response.data.refreshToken);

    const user = response.data.user;
    return user;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const logout = async () => {
  try {
    const response = await logoutApi();
    return response.data;
  } catch (error) {
    console.log(error);
  } finally {
    localStorage.clear();
  }
};
